import moment from 'moment';

export class RootState {
    public moisEnCours: string = moment().format('YYYY-MM');
}
